const config = {
    baseEndpoint: 'https://ir.design-portfolio.co.uk',
    companyID: 67,
    dateFormat: 'DD MMM Y',
    articlesPerPage: 10
};

export default config;
